/* global process */
import React from 'react';
import PropTypes from 'prop-types';
import Draggable from 'react-draggable';
import questionHelperService from '../../services/questionView/QuestionHelperServices';
import presignUrlService from '../../services/PresignUrlService';

import styles from './QuestionPDFPanelDisplay.scss';

class QuestionPDFPanelDisplay extends React.Component {
    static propTypes = {
        model: PropTypes.object.isRequired,
        onReady: PropTypes.func.isRequired,
        presignedUrlsForPDFPanel: PropTypes.object,
        questionContentRevisionId: PropTypes.number.isRequired,
        stimulusPosition: PropTypes.string,
    };

    state = {
        position: {
            x: 0, y: 0,
        },
        resizeAxis: 'v',
        pdfPanelHeight: 500,
    };

    componentDidMount() {
        this.showPanel();
        this.calculateInteraction();
        const qtiElement = Array.from(this.pdfPanel.parentElement.children).find(child =>
            child.id.includes(`question-${this.props.questionContentRevisionId}`)
        );
        setTimeout(() => {
            if (qtiElement.offsetHeight > this.state.pdfPanelHeight) {
                this.setState({ pdfPanelHeight: qtiElement.offsetHeight });
            }
        }, 100);
        this.refreshPresignedUrlIfNeeded();
    }

    componentDidUpdate() {
        this.refreshPresignedUrlIfNeeded();
    }

    refreshPresignedUrlIfNeeded = () => {
        const { model, presignedUrlsForPDFPanel } = this.props;
        if (model.pdfSourceUrl && !presignUrlService.isValidPresignedUrl(presignedUrlsForPDFPanel)) {
            presignUrlService.loadPresignedUrl(model.logicalName, model.pdfSourceUrl);
        }
    };

    calculateInteraction = () => {
        const dragBarRightElement = this.dragBarRight;
        const PDFPanelElement = this.pdfPanel;
        this.setState({
            interactionWidth: parseInt(PDFPanelElement.parentElement.offsetWidth, 10) - parseInt(dragBarRightElement.offsetWidth, 10),
            dragBarRightOffset: parseInt(dragBarRightElement.offsetLeft, 10),
        });
    };

    handleRightBarDrag = (e, ui) => {
        const { x, y } = this.state.position;
        this.setState({
            position: { x: x + ui.deltaX, y },
        });
    };

    handleBottomBarDrag = (e, ui) => {
        const { x, y } = this.state.position;
        this.setState({
            position: { x, y: y + ui.deltaY },
        });
    };

    resizePanelHorizontally = () => {
        this.setState({
            showIFrame: false,
            resizeAxis: 'h',
        });
    };

    resizePanelVertically = () => {
        this.setState({
            showIFrame: false,
            resizeAxis: 'v',
        });
    };

    showPanel = () => {
        this.setState({
            showIFrame: true,
        });
    };

    generatePDFViewerUrl = () => {
        const { model, presignedUrlsForPDFPanel } = this.props;
        const pdfJsService = questionHelperService.getServices().pdfJsService;

        if (window.offlineMode) {
            return pdfJsService.getOfflinePdfJsUrl(model.logicalName);
        }

        return pdfJsService.getPdfJsUrl(presignedUrlsForPDFPanel.presignedUrl);
    };

    onError = () => {
        this.props.onReady(false);
    };

    onReady = () => {
        this.props.onReady(true);
    };

    render() {
        const { model, presignedUrlsForPDFPanel, stimulusPosition } = this.props;
        const { interactionWidth, dragBarRightOffset, pdfPanelHeight, position, resizeAxis, showIFrame } = this.state;
        const iFrameStyle = { visibility: showIFrame ? 'visible' : 'hidden' };
        const pdfStartWidth = stimulusPosition === 'left' ? '100%' : '45%';
        const width = model.isMainMedia ? '100%' : `calc(${pdfStartWidth} + ${parseInt(position.x.toFixed(0), 10)}px)`;
        const PDFPanelStyle = {
            width,
            height: `${pdfPanelHeight + parseInt(position.y.toFixed(0), 10)}px`,
        };
        const wrapperClassNames = `${styles.PDFIframeWrapper}${showIFrame ? ' showIFrame' : ''}`;

        return (
            <div className={styles.PDFPanel} style={PDFPanelStyle} ref={(pdfPanel) => { this.pdfPanel = pdfPanel; }}>
                <div className={wrapperClassNames}>
                    {
                        showIFrame
                            ? null
                            : <i className={`fa fa-arrows-${resizeAxis}`} aria-hidden="true" />
                    }
                    {
                        presignUrlService.isValidPresignedUrl(presignedUrlsForPDFPanel) || window.offlineMode ?
                            <iframe
                                onError={this.onError}
                                onLoad={this.onReady}
                                src={this.generatePDFViewerUrl()}
                                style={iFrameStyle}
                                title="pdf"
                            />
                            : null
                    }

                </div>
                <Draggable
                    axis="none"
                    bounds={{ left: -dragBarRightOffset, right: interactionWidth - dragBarRightOffset }}
                    onDrag={this.handleRightBarDrag}
                    onStart={this.resizePanelHorizontally}
                    onStop={this.showPanel}
                >
                    <div className={styles.dragBarRight} ref={(dragBarRight) => { this.dragBarRight = dragBarRight; }}>
                        <i className="fa fa-ellipsis-v" aria-hidden="true" />
                    </div>
                </Draggable>
                <Draggable
                    position={{ x: 0, y: 0 }}
                    axis="none"
                    onDrag={this.handleBottomBarDrag}
                    onStart={this.resizePanelVertically}
                    onStop={this.showPanel}
                >
                    <div className={styles.dragBarBottom}>
                        <i className="fa fa-ellipsis-h" aria-hidden="true" />
                    </div>
                </Draggable>
            </div>
        );
    }
}

export default QuestionPDFPanelDisplay;
